import { useState, useEffect } from 'react';
import { DateTime } from 'luxon';
import PressContactComponent from '../PressContact/index';
import type IPressContact from '../../../../models/press/press-contact.model';
import { PressContactApiModel } from '../../models/press-contact.api-model';
import type { IPaginationResult } from '../../../../models/pagination-result.model';
import type PaginationResultApiModel from '../../../../services/pagination-result.api-model';
import { PressContactsApiModel } from '../../models/press-contacts.api-model';
import Spinner from '../../../Shared/Spinner';
import { TranslationService } from '../../../../services/translation.service';
import { Status } from '../../../../hooks/fetch.hook';
import Alert from '../../../Shared/Alert';

async function getPressContacts(limit: number, offset: number): Promise<IPaginationResult<IPressContact>> {
  const response = await fetch(`/api/pressinformation/contacts?limit=${limit}&offset=${offset}`);
  if (!response.ok) throw new Error(response.statusText);

  const result: PaginationResultApiModel<PressContactApiModel> = await response.json();
  return PressContactsApiModel.mapToBusinessModel(result);
}

function PressContactsTabPanel({ active = false }: { active: boolean }) {
  const limit = 100;

  const [status, setStatus] = useState({ status: Status.notperformed, updated: DateTime.now() });
  const [items, setItems] = useState<IPressContact[]>([]);
  const [currentOffset, setCurrentOffset] = useState(0);

  useEffect(() => {
    async function fetchData() {
      try {
        setStatus({ status: Status.loading, updated: DateTime.now() });
        const result = await getPressContacts(limit, currentOffset);
        setCurrentOffset(currentOffset + result.count);
        setItems([...items, ...result.results]);
        setStatus({ status: Status.success, updated: DateTime.now() });
      } catch {
        setStatus({ status: Status.failed, updated: DateTime.now() });
      }
    }
    if (active && !items.length) {
      fetchData();
    }
  }, [active, currentOffset, items]);

  return (
    <div className="tab-panel">
      {items && (
        <ol className="row p-0">
          {items.map((pressContact) => (
            <li key={pressContact.id} className={`${pressContact.type === 'contact' ? 'col-12 col-sm-6 col-md-4 mb-4 mb-sm-5' : 'col-12 mb-4'}`}>
              {pressContact.type === 'contact' && <PressContactComponent pressContact={pressContact} />}
              {pressContact.type === 'department' && <h3 className="text-center">{pressContact.name}</h3>}
            </li>
          ))}
        </ol>
      )}
      {status.status === Status.loading && <Spinner delayInMs={300} className="my-3" />}
      <Alert show={status.status === Status.failed} heading={TranslationService.get('presspage.generalerror')} headingTag="h3" closable={false} />
    </div>
  );
}

export default PressContactsTabPanel;